var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { observer } from 'mobx-react';
import React, { Component } from 'react';
import { Card, CardContent, Heading, Modal, ModalContent, ModalProvider, Separator } from 'telia-front-react';
import TradeInRootStore from '../stores/TradeInRootStore';
import TradeInCalculator from './TradeInCalculator';
import TradeInSelection from './TradeInSelection';
import TradeInSuccessModal from './TradeInSuccessModal';
let rootStore;
let TradeInCalculatorStateWrapper = class TradeInCalculatorStateWrapper extends Component {
    constructor(props) {
        super(props);
        if (rootStore === undefined) {
            rootStore = new TradeInRootStore(props);
        }
        if (!!this.props.promotedManufacturers) {
            rootStore.tradeInStore.setPromotedManufacturers(this.props.promotedManufacturers);
        }
    }
    componentDidMount() {
        rootStore.tradeInStore.initialize();
    }
    componentWillUnmount() {
        rootStore.tradeInStore.disposeReactions();
    }
    componentDidUpdate(prevProps) {
        rootStore.mergeStoreState(prevProps, this.props);
    }
    renderInModal(props) {
        return (React.createElement(ModalProvider, { id: 'trade-in-modal', isClosable: true, isOpen: props.modalOpen, onToggle: props.onModalToggle },
            React.createElement(Modal, { hasContentComponent: true, size: props.modalSize, verticalAlign: "top", isFullHeight: props.modalFullHeight === undefined ? true : props.modalFullHeight, "aria-labelledby": "trade-in-title" },
                React.createElement(ModalContent, { background: "neutral-bg-level-2" },
                    React.createElement(Heading, { level: props.modalHeadingLevel || 1, className: "h2 text-center", id: "trade-in-title" }, props.modalTitle),
                    React.createElement(Separator, { spacing: "xsmall", color: "invisible" }),
                    this.renderCalculator(props)))));
    }
    renderCalculator(props) {
        const { headingElement = 'h3', translate, isLoggedIn } = props;
        return (React.createElement(Card, null,
            React.createElement(CardContent, { padding: this.props.inModal ? 'xsmall' : 'medium' },
                React.createElement(TradeInSelection, { headingElement: headingElement, translate: translate, tradeInStore: rootStore.tradeInStore }),
                React.createElement(TradeInCalculator, { headingElement: headingElement, tradeInStore: rootStore.tradeInStore, translate: translate, isLoggedIn: isLoggedIn }))));
    }
    renderSuccessModal(props) {
        const { tradeInSuccessContent } = props;
        return (React.createElement(TradeInSuccessModal, { tradeInStore: rootStore.tradeInStore, tradeInSuccessContent: tradeInSuccessContent({
                category: rootStore.tradeInStore.shopCategory,
                price: rootStore.tradeInStore.finalPrice,
            }) }));
    }
    render() {
        return (React.createElement(React.Fragment, null,
            this.props.inModal ? this.renderInModal(this.props) : this.renderCalculator(this.props),
            this.renderSuccessModal(this.props)));
    }
};
TradeInCalculatorStateWrapper = __decorate([
    observer
], TradeInCalculatorStateWrapper);
export { TradeInCalculatorStateWrapper };
